module.exports = __webpack_public_path__ + "static/media/icon-tattoo.be77a79c.svg";